import XEUtils from 'xe-utils'
import 'vxe-table-quantdata/lib/style.css'
import Vue from 'vue'
import httpManager from '../../util/common'

Vue.use('vxe-utils');
Vue.use('vxe-table');

let vm = {
  delimiters: ['{', '}'],
  props: ['oaid'],
  data: () => {
    return {
      s_tableColumn: [],
      c_tableColumn: [],
      s_loading: false,
      c_loading: false,
      s_data: [],
      c_data: [],
      exportConfig: {},
    }
  },
  methods: {
    cellClickEvent({row, column}) {
      const {
        href
      } = this.$router.resolve({path:  '/entity/'+row.oa_id_counterparty+'/home'})
      window.open(href, '_blank')
    },

    getData() {
      let self = this
      self.s_loading = true
      self.c_loading = true
      let params = new Map()
      params.set("pagenum", 1)
      params.set("pagesize", 5)
      params.set('oaid', self.oaid)
      params.set('relation_type', "供应商")
      httpManager("sc_influence", params, null, null, null)
        .then(response => {
          self.s_data = response.data.data
          self.s_loading = false
        })
        .catch(error => {
          console.log(error)
          self.s_loading = false
        })
      params.set('relation_type', "客户")
      httpManager("sc_influence", params, null, null, null)
        .then(response => {
          self.c_data = response.data.data
          self.c_loading = false
        })
        .catch(error => {
          console.log(error)
          self.c_loading = false
        })
    },

  },
  mounted() {
    this.s_tableColumn=[
        {type: 'seq', title: this.$t('supplychain.ranking'),  width: 50},
        {title: this.$t('supplychain.top_5_suppliers'), field: "counterparty_name", width: '42%'},
        {title: this.$t('supplychain.security_ticker'), field: "ticker_counterparty"},
        {title: this.$t('supplychain.suppliers_influence'), field: "supplier_influenced_weight", formatter: ({ cellValue })=>{return cellValue ? `${XEUtils.commafy(XEUtils.toNumber(cellValue), { digits: 2 })}`:''}},
      ]
    this.c_tableColumn=[
        {type: 'seq', title: this.$t('supplychain.ranking'),  width: 50},
        {title: this.$t('supplychain.top_5_customers'), field: "counterparty_name", width: '42%'},
        {title: this.$t('supplychain.security_ticker'), field: "ticker_counterparty"},
        {title: this.$t('supplychain.customers_influence'), field: "customer_influenced_weight", formatter: ({ cellValue })=>{return cellValue ? `${XEUtils.commafy(XEUtils.toNumber(cellValue), { digits: 2 })}`:''}},
      ]
    this.getData()
  },
  watch: {
    relation_type: function () {
      this.page.currentPage = 1
      this.getData()
    },

  },
  created(){
  }
}
Vue.component("entity-sc-influence", vm)
export default vm



// WEBPACK FOOTER //
// ./src/entity/js/entity_sc_influence.js